/* =========================================================
   GoldHearted analytics bridge — V118
   Google: uses the on-page Google tag installed by the official
   Google & YouTube app. No Google tag is loaded inside Shopify's
   Custom Pixel sandbox.
   Meta: continues receiving GoldHearted custom events through
   Shopify customer events / the separate Meta custom pixel.
========================================================= */
(function () {
  'use strict';

  var GH_GA4_DESTINATION = 'G-43M69XQHDP';
  var GH_SHOPIFY_EVENT_PREFIX = 'goldhearted:';
  var GH_SIGNUP_FORMS = {
    ghGrillzWaitlistForm: ['grillz_waitlist', 'product_waitlist'],
    ghXpEmailSignupForm: ['newsletter', 'email_marketing'],
    ghEduInlineSignupForm: ['edu_email_list', 'edu_email']
  };

  function getPagePath() {
    try { return window.location.pathname + window.location.search; }
    catch (error) { return ''; }
  }

  function cleanParams(params) {
    var safe = {};
    var source = params || {};
    Object.keys(source).forEach(function (key) {
      var value = source[key];
      if (value === undefined || value === null || value === '') return;
      safe[key] = value;
    });
    return safe;
  }

  function sendGoogleEvent(eventName, params) {
    var payload = cleanParams(params);
    payload.send_to = GH_GA4_DESTINATION;

    try {
      // Use the Google tag already installed on the storefront by Google's
      // official Shopify integration. If gtag is not exposed yet, queue the
      // same command on the standard dataLayer for gtag.js to consume.
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(['event', eventName, payload]);
      }
      return true;
    } catch (error) {
      console.warn('[GoldHearted Analytics V118] Google event failed:', eventName, error);
      return false;
    }
  }

  function publishShopifyCustomEvent(eventName, payload, attempt) {
    var tryNumber = Number(attempt || 0);
    var maxAttempts = 24;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var result = window.Shopify.analytics.publish(GH_SHOPIFY_EVENT_PREFIX + eventName, payload);
        if (result && typeof result.catch === 'function') {
          result.catch(function (error) {
            console.warn('[GoldHearted Analytics V118] Shopify custom event publish rejected:', eventName, error);
          });
        }
        return true;
      }
    } catch (error) {
      console.warn('[GoldHearted Analytics V118] Shopify publish failed:', eventName, error);
    }
    if (tryNumber < maxAttempts) {
      window.setTimeout(function () { publishShopifyCustomEvent(eventName, payload, tryNumber + 1); }, 250);
      return true;
    }
    return false;
  }

  function track(eventName, params) {
    if (!eventName) return false;
    var payload = cleanParams(params);
    payload.page_path = payload.page_path || getPagePath();

    // Google custom events run on-page through the official Google tag.
    // Shopify custom events remain available to Meta and any other pixels.
    sendGoogleEvent(eventName, payload);
    publishShopifyCustomEvent(eventName, payload);
    return true;
  }

  function trackLead(leadType, formId, extraParams) {
    var payload = Object.assign({
      lead_type: leadType,
      lead_category: 'custom_jewelry',
      form_id: formId,
      interaction_surface: 'xp_desktop'
    }, extraParams || {});
    return track('generate_lead', payload);
  }

  function bindSignupGa4() {
    Object.keys(GH_SIGNUP_FORMS).forEach(function (formId) {
      var form = document.getElementById(formId);
      if (!form || form.dataset.ghGa4V118Bound === '1') return;
      form.dataset.ghGa4V118Bound = '1';

      form.addEventListener('submit', function () {
        var def = GH_SIGNUP_FORMS[formId];
        sendGoogleEvent('gh_signup_submit', {
          signup_type: def[0],
          signup_category: def[1],
          form_id: formId,
          interaction_surface: 'xp_desktop',
          page_path: getPagePath()
        });
      }, { capture: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSignupGa4, { once: true });
  } else {
    bindSignupGa4();
  }

  window.GHAnalytics = Object.assign(window.GHAnalytics || {}, {
    build: 'v118',
    measurementId: GH_GA4_DESTINATION,
    track: track,
    trackLead: trackLead,
    sendGoogleEvent: sendGoogleEvent
  });
})();
